import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import bloodAndGold from '../images/Blood & Gold_Production_FINAL_MIDRES_WEB-4096.jpg'
import blackHands from '../images/BLACK-HANDS.png'
import cleaver from '../images/CLEAVER.png'
import everybodyElse from '../images/EVERYBODY-ELSE-IS-TAKEN.png'
import flip from '../images/FLIP.jpg'
import foodie from '../images/FOODIE.jpg'
import mystic from '../images/MYSTIC.3.jpg'
import powerRangers from '../images/POWER RANGERS 3 copy.jpg'
import stranger from '../images/STRANGER.png'
import theCalf from '../images/THE-CALF.jpg'
import turtleBankHustler from '../images/TURTLE-BANK-HUSTLER.png'

const testData = {
  pageTitle: "COACHING",
  pageInfo: [
    `Ella coaches actors to a deeper understanding of their limitless capacity as performers and people. She has been doing this for seven years now.`,
    `Mentored by NZ coaching legend Miranda Harcourt, Ella has the privilege of her full support across all projects. Miranda's generosity of time and counsel has undoubtedly accelerated Ella’s skill and experience.`,
    `Ella makes room for actors to bravely bring their offers forward, both in rehearsal and on set, empowering them to trust themselves and their instincts. She is also a staunch advocate for sustaining health and wellbeing.`,
    `At the beginning of a process she takes time to strongly connect actors with their cast and director. Laying out the expectations, fears and possibilities that are present in a new project. She is able to get directors and actors on the same Waka (boat), with a greater sense of trust, shared language and rigour, quickly.`,
    `Ella sensitively builds powerful performances with actors in direct relationship to the production and director's vision. On set she is a grounding and guiding force.`,
    `Not afraid to challenge, not afraid to celebrate, she will lift any performer to new and surprising places of connection, truth and depth.`
  ],
  quotes: [
    {
      attribution: "Miranda Harcourt",
      text: `Ella is magic. She has all the skills — she is creative, grounded, practical, imaginative. She is a great planner and collaborator. She is a great carer and motivator. I always want her on a team!`
    },
    {
      attribution: "Peter Salmon",
      text: `Ella's coaching skills were invaluable for me directing 'Mystic'. Her down-to-earth, intuitive approach with the young cast created a trusting environment resulting in fantastic memorable performances`
    },
    {
      attribution: "Jacqueline Jo",
      text: `She has this amazing way of connecting with people that make them feel calm and confident in themselves`
    }
  ],
  content: [
    {
      title: "POWER RANGERS",
      link: "/power-rangers",
      image: powerRangers
    },
    {
      title: "BLACK HANDS",
      link: "/black-hands",
      image: blackHands
    },
    {
      title: "MYSTIC",
      link: "/mystic",
      image: mystic
    },
    {
      title: "THE CALF",
      link: "/the-calf",
      image: theCalf
    },
    {
      title: "FLIP",
      link: "/flip",
      image: flip
    },
    {
      title: "FOODIE",
      link: "/foodie",
      image: foodie
    },
    {
      title: "BLOOD AND GOLD",
      link: "/blood-and-gold",
      image: bloodAndGold
    },
    {
      title: "CLEAVER",
      link: "/cleaver",
      image: cleaver
    },
    {
      title: "STRANGER",
      link: "/stranger",
      image: stranger
    },
    {
      title: "EVERYBODY ELSE IS TAKEN",
      link: "/everybody-else-is-taken",
      image: everybodyElse
    },
    {
      title: "TURTLE BANK HUSTLER",
      link: "/turtle-bank-hustler",
      image: turtleBankHustler
    }
  ]
}

function MainPage() {
  const [isExpanded, setIsExpanded] = useState(false)

  function colourise(e) {
    e.target.style.filter = 'grayscale(0%)';
  }

  function decolourise(e) {
    e.target.style.filter = 'grayscale(100%)';
  }

  function readMore(e) {
    if(!isExpanded) {
      document.querySelector('.read-more').style.visibility = 'hidden';
      document.querySelector('.Expand').style.maxHeight = '9999px';
      setIsExpanded(true);
    }

  }

  function readLess(e) {
    document.querySelector('.read-more').style.visibility = 'visible';
    document.querySelector('.Expand').style.maxHeight = '200px';
    setIsExpanded(false);
  }

  return (
    <div className="Main-page container">
      <h1 className="title">{testData.pageTitle}</h1>
      <div className="row">
        <div className="col" onClick={readMore}>
          <div className="Main-info Expand row">
            <div className="col-md">
                <div className="Quotes">
                  <p>
                    <strong>"{testData.quotes[0].text}"</strong>
                    <br />
              - {testData.quotes[0].attribution}
                  </p>
                </div>
                <div className="Quotes">
                  <p>
                    <strong>"{testData.quotes[1].text}"</strong>
                    <br />
              - {testData.quotes[1].attribution}
                  </p>
                </div>
                <div className="Quotes">
                  <p>
                    <strong>"{testData.quotes[2].text}"</strong>
                    <br />
              - {testData.quotes[2].attribution}
                  </p>
                </div>
            </div>
            <div className="col-md">
              <br />
                <p>
                  {testData.pageInfo[0]}
                </p>
                <p>
                  {testData.pageInfo[1]}
                </p>
                <p>
                  {testData.pageInfo[2]}
                </p>
                <p>
                  {testData.pageInfo[3]}
                </p>
                <p>
                  {testData.pageInfo[4]}
                </p>
                <p>
                  {testData.pageInfo[5]}
                </p>
            </div>
            <div className="row">
              <p className="read-more"></p>
              <a href="#" className="read-more-button" onClick={readLess}><strong>{isExpanded ? 'LESS' : 'MORE'}...</strong></a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[0].link}>
            <img
              src={testData.content[0].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
              <h1 className="title-power-rangers"><strong>{testData.content[0].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[1].link}>
            <img
              src={testData.content[1].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[1].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[2].link}>
            <img
              src={testData.content[2].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[2].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[3].link}>
            <img
              src={testData.content[3].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[3].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[4].link}>
            <img
              src={testData.content[4].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[4].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[5].link}>
            <img
              src={testData.content[5].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[5].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[6].link}>
            <img
              src={testData.content[6].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-blood-bone"><strong>{testData.content[6].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[7].link}>
            <img
              src={testData.content[7].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-black"><strong>{testData.content[7].title}</strong></h1>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="main-pic col-md">
          <Link to={testData.content[8].link}>
            <img
              src={testData.content[8].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-white"><strong>{testData.content[8].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[9].link}>
            <img
              src={testData.content[9].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-everybody-else"><strong>{testData.content[9].title}</strong></h1>
          </Link>
        </div>
        <div className="main-pic col-md">
          <Link to={testData.content[10].link}>
            <img
              src={testData.content[10].image}
              className="main-img"
              onMouseEnter={colourise}
              onMouseLeave={decolourise} />
            <h1 className="title-turtle-bank"><strong>{testData.content[10].title}</strong></h1>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default MainPage
